import {PearlHarborGameAssets} from "../PearlHarborGameAssets";
import {TweenLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {BitMapMultiplier} from "./freespin/component/BitMapMultiplier";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborSymbol} from "../reels/PearlHarborSymbol";
import {PearlHarborScatterSymbol} from "../reels/PearlHarborScatterSymbol";

export class ScatterCounter extends PIXI.Container {
    private readonly ACTIVE_TEXTURES: string[] = ["scatterCounter1On","scatterCounter1On","scatterCounter1On","scatterCounter2On"];
    private readonly INACTIVE_TEXTURES: string[] =["scatterCounter1","scatterCounter1","scatterCounter1","scatterCounter2"];
    private readonly MULTI_INACTIVE_TEXTURE: string = "scatterCounterMultiplierOn";
    private _counter: PIXI.Sprite[];
    private _multi: PIXI.Sprite;
    private _multiText: BitMapMultiplier;
    private _scatterCount: number = -1;

    constructor() {
        super();
        this.init();
    }

    get multiplierPos(): number[] {
        return [this.position.x+this._multiText.x,this.position.y+this._multiText.y];
    }

    get value(): number {
        return this._multiText.value;
    }

    set value(value: number) {
        if(value>PearlHarbor.model.scatterMultiplier){
            debugger;
            return;
        }
        if(value<=1){
            this._multiText.visible = false;
            this._multiText.value = value;
            return;
        }
        this._multiText.visible = true;
        if (value > this._multiText.value) {
            this.playScaleAnim(value);
            PearlHarborSoundManager.playScatterMultiplierUpdate();
        }
        this._multiText.value = value;
    }

    private playScaleAnim(value: number): void {
        const toScale: number = (value > 4 ? 1.5 : 1.2); // #406
        TweenLite.to(this._multiText.scale, 0.25, {
            x: toScale, y: toScale, onComplete: () => {
                TweenLite.to(this._multiText.scale, 0.15, {x: 1, y: 1});
            }
        });
    }

    public enableCounter() {
        this._scatterCount++;
        if(this._scatterCount>=2){
            //2scatters
            PearlHarbor.scatterAnimation.playTriggerAnim();
        }else if(this._scatterCount===1){
            //1 scatter
            PearlHarbor.scatterAnimation.playAnticipation();
        }
        if(this._scatterCount<4){
            this._counter[this._scatterCount].texture =PearlHarbor.assetLoader.getTextures(this.ACTIVE_TEXTURES[this._scatterCount])[0];
        }
    }


    public restore():void{
        PearlHarbor.model.scatterPositions.forEach((pos:number[])=>{
            let symbol: PearlHarborSymbol = <PearlHarborSymbol>PearlHarbor.allReelsView.mainReelModels[pos[0]].getSymbol(pos[1]);
            if(symbol.symbolName.indexOf("BN")<-1){
                debugger;
            }
            if(symbol.isActivated){
                this.enableCounter();
                (<PearlHarborScatterSymbol>symbol).playScatterTriggerAnim(false);
            }
        });
        this.value = PearlHarbor.model.scatterMultiplier;
    }

    set inactive(id: number) {
        this._counter[id].texture = PearlHarbor.assetLoader.getTextures(this.INACTIVE_TEXTURES[id])[0];
    }

    public showLayer(): void {
        this.visible = true;
        TweenLite.to(this, 0.1, {alpha: 1});
    }

    public hideLayer(): void {
        new TimelineLite().add(TweenLite.to(this, 0.1, {alpha: 0}))
            .add(() => {this.visible = false;});
    }


    public adjustComponents(): void {
        if(NolimitApplication.isLandscape){
            this._counter.forEach((counter:PIXI.Sprite, i:number)=>{
                counter.x = 0;
                counter.y = i*45;
            });
            this._multi.position.set(0, 180);
        }else{
            this._counter.forEach((counter:PIXI.Sprite, i:number)=>{
                counter.x = i*68;
                counter.y = 0;
            });
            this._multi.position.set(68*4, -19);
        }
    }

    public reset(): void {
        this._scatterCount = -1;
        this._counter.forEach((counter:PIXI.Sprite, i:number)=>{
            counter.texture = PearlHarbor.assetLoader.getTextures(this.INACTIVE_TEXTURES[i])[0];
        });
        this.value = 0;
    }

    private addScatterCounter(id:number): PIXI.Sprite {
        const sprite:PIXI.Sprite = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures(this.INACTIVE_TEXTURES[id])[0]);
        sprite.anchor.set(0,0);
        this.addChild(sprite);
        return sprite
    }

    private init(): void {
        this._counter = ArrayHelper.initArrayWithValues(4, (i:number)=>{return this.addScatterCounter(i)});
        this._multi = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures(this.MULTI_INACTIVE_TEXTURE)[0]);
        this._multi.anchor.set(0,0);
        this._multiText = new BitMapMultiplier(PearlHarborGameAssets.BITMAP_FONT_MULTIPLIER, 30, "x");
        this._multi.addChild(this._multiText);

        this._multiText.position.set(34,34);
        this.addChild(this._multi);
        this.value = 0;
        this._scatterCount = -1;
    }
}